<script>
export default {
  props: {
    size: {
      type: String,
      default: '24',
    },
    colour: {
      type: String,
      default: 'primary',
    },
  },
}
</script>

<template>
  <div class="w-full d-flex justify-center items-center">
    <v-progress-circular
      indeterminate
      :color="colour"
      :size="size"
    ></v-progress-circular>
  </div>
</template>
